module.exports = __webpack_public_path__ + "flyer_background_live_music_031-8c0a3c2ebb4aa6184a494d492e79c597.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_live_music_031.jpg
// module id = 1659
// module chunks = 1